import moment from 'moment';
import {Term} from 'store/services/termsServices';

interface TermInfo {
  name: string;
  isReadonly: boolean;
  id: string;
  title: string;
}
export interface TermsSectionProps {
  terms: Term[];
  data: TermInfo[];
}

const TermsSection: React.FC<TermsSectionProps> = ({data, terms}) => {
  const markdown =
    data &&
    data
      .map((term) => {
        const termsInfo =
          terms && terms.find((termsItem) => termsItem.parameter === term.name);

        return `<h4><b>${term.title}</b></h4>
        ${
          termsInfo?.parameter === 'terms_privacy_text'
            ? `
          <div style="margin-top: 2rem; margin-bottom: 2rem;">
            <p>
              Fonte:
              <a href="/privacidade" target="_blank">
                www.aluno.letrus.com.br/privacidade/
              </a>
            </p>
            <p>
              Última atualização:
              ${moment(termsInfo.modified).format('DD/MM/YYYY')}
            </p>
          </div>
        `
            : ``
        }
        <div>${termsInfo && termsInfo.value}</div>`;
      })
      .join(`<div style="margin-top: 5rem"></div>`);

  return <div dangerouslySetInnerHTML={{__html: markdown}} />;
};

export default TermsSection;
